import moment from 'moment-timezone';
import { connect } from 'react-redux';
import {
	readWorkOrderStar,
	upsertWorkOrderStar,
	removeWorkOrderStar,
} from '../../thunks/work_order_user_stars_thunks';
import { WorkOrderUserStar } from '../../data/workOrderStarLabels';
import { canAddWOLabelsOrStarNotes } from '../../utils/DataAccessUtils';

export interface StarActionProps {
	// Notes and reminders are both Pro features behind the same entitlement.
	canAddNote: boolean;
	upsertWorkOrderStar: (
		workOrderId: number | string,
		starNote: string | null,
		remindAt?: moment.Moment | null,
		remindCondition?: string | null
	) => Promise<any>;
	removeWorkOrderStar: (workOrderId: number | string) => Promise<any>;
	// The star as the server has it (see readWorkOrderStar): null once untracked, undefined if unknown.
	readWorkOrderStar: (
		workOrderId: number | string
	) => Promise<Partial<WorkOrderUserStar> | null | undefined>;
	// The session's role (buyer | supplier): the star endpoints and the toast's work order link use it.
	roleType: string;
}

const mapStateToProps = (state) => ({
	userType: state.session.userType,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({ dispatch });
const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const { userType, currentUser } = stateProps;
	const { dispatch } = dispatchProps;
	return {
		...ownProps,
		canAddNote: canAddWOLabelsOrStarNotes(currentUser),
		roleType: userType,
		upsertWorkOrderStar: (
			workOrderId: number | string,
			starNote: string | null,
			remindAt?: moment.Moment | null,
			remindCondition?: string | null
		) => dispatch(upsertWorkOrderStar(userType)(workOrderId, starNote, remindAt, remindCondition)),
		removeWorkOrderStar: (workOrderId: number | string) =>
			dispatch(removeWorkOrderStar(userType)(workOrderId)),
		readWorkOrderStar: (workOrderId: number | string) =>
			dispatch(readWorkOrderStar(userType)(workOrderId)),
	};
};

// Binds the role-appropriate star thunks (the role comes from the session) for any component
// that tracks, untracks, snoozes or stops a work order reminder.
const connectStarActions = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default connectStarActions;
